<template>
  
  <v-flex xs12 sm12 md12 class="mt-3">
    <v-card>
      <v-card-text class="mt-0">

        <BoxHeader 
          :questionObj="question" 
          title="Multiple choices">
        </BoxHeader>

        <!-- Question -->
        <v-textarea 
          :counter="250"
          label="Write question here"
          v-model="questionText"
          v-on:input="setTextForQuestionObj($event)" 
          :rules="[rules.required]"
          hint="Use tab key to add the first option."
          auto-grow
          autofocus
        ></v-textarea>

        <v-text-field 
          v-for="item in this.items"
          :ref="item.optionId"
          clearable 
          :value="item.value" 
          :rules="[rules.required]"
          placeholder="Option" 
          prepend-icon="check_box_outline_blank" 
          hint="Tip: Enter to add an option. Up and down arrow to move."
          v-on:input="addTextForOption($event, item)" 
          v-on:keydown.enter.prevent="addRow()"
          v-on:keydown.up="moveUp($event, item)"
          v-on:keydown.down="moveDown($event, item)"
          append-icon="delete_forever"
          @click:append="deleteRow($event, item)">
        </v-text-field>

        <v-btn flat large block color="teal" @click="addRow()">
          <v-icon dark>add</v-icon> Add option
        </v-btn>
      </v-card-text>

    </v-card>
  </v-flex>

</template>

<script>
// @ is an alias to /src
import BoxHeader from '@/components/questionForms/BoxHeader.vue'

export default {
  name: "checkbox",
  components: {
    BoxHeader
  },
  props: {
    question: Object
  },
  data: () => ({
    questionText: null,
    items: [],
    rules: {
      required: value => !!value || 'Cannot Be Empty.'
    }
  }),
  computed: {},
  created() {

    this.questionText = this.question.text;

    const option = {
      optionId: this.$uuid.v1(),
      value: null
    };

    if (!this.question.items) {
      this.question.items = [];
      this.question.items.push(option);
    }
    
    this.items = this.question.items;
  },
  methods: {
    setTextForQuestionObj(text) {
      
      this.$store.commit('setTextForQuestionObj', {questionObj: this.question, text:text});
    },

    addTextForOption(value, optionObj) {
      // var optionId = option.optionId;
      // optionObj.value = value;
      this.$store.commit('setValueForOptionObj', {optionObj: optionObj, value:value});
    },

    addRow() {
      const option = {
        optionId: this.$uuid.v1(),
        value: null
      };

      this.question.items.push(option);
      this.items = this.question.items;

      // Move the cursor to the last row  
      if (this.items.length > 1){ 
        this.moveDown(null, this.items[this.items.length-2])    
      }
    },

    moveUp(evt, optionObj) {
      // Get index of current item
      const index = this._.findIndex(this.items, (item)=>{
        return item.optionId === optionObj.optionId;
      });

      // Do not allow moving if out of index
      if (index === 0) return;

      // Move to the next element
      const nextItem = this.items[index-1].optionId;
      this.$nextTick(() => this.$refs[nextItem][0].focus());
    },

    moveDown(evt, optionObj) {
      // Get index of current item
      const index = this._.findIndex(this.items, (item)=>{
        return item.optionId === optionObj.optionId;
      });

      // Do not allow moving if out of index
      if (index === this.items.length - 1) return;

      // Move to the next element
      const nextItem = this.items[index+1].optionId;
      this.$nextTick(() => this.$refs[nextItem][0].focus());
    },
    
    deleteRow(evt, optionObj) {
      this.$nextTick(() => {
        const arg = { items:this.items, optionObj:optionObj};
        this.$store.commit('removeOptionFromForm', arg);
        this.$forceUpdate()
      });
    }
  }
};
</script>

<style scoped>

</style>